export default {
  cardholder_name: 'Nom complet',
  cardholder_name_placeholder: 'Nom sur la carte',
  card_number: 'Numéro de carte',
  card_number_placeholder: '1234 5678 9012 3456',
  expiry: "Date d'expiration",
  expiry_placeholder: 'MM / AA',
  cvv: 'Code de sécurité',
  cvv_label: 'Code de sécurité (CVC)',
  cvv_placeholder: 'CVC',
  loading: 'Initialisation du formulaire sécurisé…',
  sdk_load_failed: "Le formulaire sécurisé n'a pas pu se charger. Vérifiez votre connexion et actualisez la page.",
  errors: {
    number_blank: 'Saisissez votre numéro de carte.',
    number_invalid: "Ce numéro de carte n'est pas valide. Vérifiez les chiffres et réessayez.",
    number_incomplete: 'Votre numéro de carte est incomplet.',
    cvv_blank: 'Saisissez le code de sécurité au dos de votre carte.',
    cvv_invalid: "Ce code de sécurité n'est pas valide. Vérifiez les 3 ou 4 chiffres de votre carte.",
    cvv_incomplete: 'Saisissez les {{count}} chiffres de votre code de sécurité.',
    expiry_invalid: "Saisissez une date d'expiration valide au format MM / AA.",
    expired: 'Cette carte a expiré. Veuillez utiliser une autre carte.',
    name_blank: 'Saisissez le nom exactement comme il apparaît sur votre carte.',
    configuration:
      'Les paiements par carte ne sont pas disponibles pour le moment. Veuillez essayer un autre moyen de paiement.',
    generic: "Nous n'avons pas pu vérifier les détails de votre carte. Veuillez réessayer.",
  },
};
